import React, { ChangeEvent, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useMyWalletPerformanceFilterLogic, walletPagePerformanceSectionMessages } from 'azshared';
import './performance-filter.scss';


export const DossierToggle = () => {
    const { formatMessage } = useIntl();
    const { performanceFilter, onPerformanceFilterChange } = 
    useMyWalletPerformanceFilterLogic();


    const handleToggleChange = useCallback(
        (event: ChangeEvent<HTMLInputElement>) => {
        onPerformanceFilterChange({
            ...performanceFilter,
            showClosedPositions: event.target.checked
        });
        },
        [performanceFilter, onPerformanceFilterChange]
    );
     
    return (
        <div className='my-wallet-section-icon'>
            <label className='my-wallet-section-icon-label toggle-container'>
                <input
                    type='checkbox'
                    checked={performanceFilter.showClosedPositions}
                    onChange={handleToggleChange}
                    className='toggle-input'
                />
                <span className='toggle-slider'></span>
                <span className='toggle-label'>{formatMessage(walletPagePerformanceSectionMessages.toggleFilter)}</span>
            </label>
        </div>
    );
};